import { makeApiCall, ApiResponse } from "./index";

const BASE_URL = process.env.REACT_APP_API_CLIENT_URL;
const TRAIL_URL = process.env.REACT_APP_API_CLIENT_URL_FREE_TRIAL;

// GET request
export function getAllClients(
  ClientTypeId: number,
  filters?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}clienttypes/${ClientTypeId}/clients`,
    "GET",
    filters,
  );
}

// POST request
export function addClient(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients`, "POST", body);
}

// PUT request
export function updateClient(
  ClientId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${ClientId}`, "PUT", body);
}

// DELETE request
export function deleteClient(ClientId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${ClientId}`, "DELETE");
}

// PATCH request
export function restoreClient(ClientId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${ClientId}`, "PATCH");
}

// GET request
export function getClientById(ClientId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${ClientId}`, "GET");
}

// GET address request
export function getAllClientAddress(
  ClientId: number,
  filters?: any,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}clients/${ClientId}/addresses`,
    "GET",
    filters,
  );
}

// POST address request
export function addClientAddress(
  ClientId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${ClientId}/addresses`, "POST", body);
}

// PUT address request
export function updateClientAddress(
  AddressId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/addresses/${AddressId}`, "PUT", body);
}

// GET address request
export function getClientAddressById(AddressId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/addresses/${AddressId}`, "GET");
}

// POST request
export function addClientLogo(
  clientId: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${clientId}/logo`, "POST", body);
}

// GET request
export function getClientLogo(clientId: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${clientId}/logo`, "GET");
}

export function getTranscripts(type: string, id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${type}/${id}/transcript`, "GET");
}

//client settings api's

// GET request
export function getClientSettings(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/settings`, "GET");
}

// POST address request
export function addClientSettings(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/settings`, "POST", body);
}

// PUT code request
export function addClientCodeSequence(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/sequences`, "PUT", body);
}

// Get code request
export function getClientCodeSequence(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/sequences`, "GET");
}

// GET request
export function getClientFeatures(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}features`, "GET");
}

export function getClientFeatureData(featureId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}features/${featureId}`, "GET");
}

/****************************referrals***********************************************************/
// Get referrals
export function getReferrals(filters?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}referrals`, "GET", {
    textSearch: filters?.textSearch,
  });
}

// POST  request
export function addReferral(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}referrals`, "POST", body);
}

// PUT  request
export function updateReferral(id?: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}referrals/${id}`, "PUT", body);
}

// Get referral
export function getReferral(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}referrals/${id}`, "GET");
}
export function deleteReferral(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}delete-referral/${id}`, "DELETE");
}
/****************************vendor***********************************************************/
// Get referrals
export function getVendors(filters?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vendors`, "GET", filters);
}

// POST  request
export function addVendors(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vendors`, "POST", body);
}

// PUT  request
export function updateVendors(id?: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vendors/${id}`, "PUT", body);
}

// Get referral
export function getVendor(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}vendors/${id}`, "GET");
}
export function deleteVendor(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}delete-vendor/${id}`, "DELETE");
}
/****************************Expense***********************************************************/
// Get referrals
export function getExpenses(filters?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenses`, "GET", filters);
}

// POST  request
export function addExpenses(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenses`, "POST", body);
}

// PUT  request
export function updateExpenses(id?: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenses/${id}`, "PUT", body);
}

// Get referral
export function getExpense(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenses/${id}`, "GET");
}

export function deleteExpense(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}delete-expense/${id}`, "DELETE");
}
/****************************ExpenseType***********************************************************/
// Expense
export function getExpensesType(
  clientId: string, // Change clientId to accept string
  categoryId: number | null,
  locationId?: number | null,
): Promise<ApiResponse> {
  let url = `${BASE_URL}expenseType/${clientId}/lists?categoryId=${categoryId}`;
  if (locationId != null) {
    url += `&locationId=${locationId}`;
  }
  return makeApiCall(url, "GET");
}

// POST  request
export function addExpenseType(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenseType`, "POST", body);
}

// PUT  request
export function updateExpenseType(
  id?: number,
  body?: any,
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenseType/${id}`, "PUT", body);
}

// Get referral
export function getExpenseType(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}expenseType/${id}`, "GET");
}

export function getPaymentGatewayDetails(
  ClientId: number,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}Payment/GetPaymentGatewayDetails?ClientId=${ClientId}`,
    "GET",
  );
}

/****************************TermsAndCOndiion***********************************************************/
// Get referrals
export function getTerms(
  clientId: string,
  queryParams: any,
): Promise<ApiResponse> {
  let url = `${BASE_URL}clients/${clientId}/termsAndConditions`;
  return makeApiCall(url, "GET", queryParams);
}

// POST  request
export function addTerms(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}termsAndConditions`, "POST", body);
}

export function updateTerms(id?: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}terms/${id}`, "PUT", body);
}

export function deleteTerms(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}delete-terms/${id}`, "DELETE");
}

export function addTrailClients(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${TRAIL_URL}trailClients`, "POST", body);
}

/**************************** Source ***********************************************************/

// Get sources by clientId
export function getSources(
  clientId: string,
  queryParams?: any,
): Promise<ApiResponse> {
  const url = `${BASE_URL}sources/${clientId}/sourceList`;
  return makeApiCall(url, "GET", queryParams);
}

// Create a new source
export function addSource(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}sources`, "POST", body);
}

// Update an existing source
export function updateSource(id: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}sources/${id}`, "PUT", body);
}

// Get a single source by Id
export function getSourceById(id: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}sources/${id}`, "GET");
}

/**************************** Payment Deposit Setting ***********************************************************/

export function getPaymentDepositSetting(
  paymentDepositSettingId: number,
): Promise<ApiResponse> {
  const url = `${BASE_URL}Payment/DepositSetting/${paymentDepositSettingId}`;
  return makeApiCall(url, "GET");
}

export function getAllPaymentDepositSetting(params: any): Promise<ApiResponse> {
  const url = `${BASE_URL}Payment/DepositSetting`;
  return makeApiCall(url, "GET", params);
}

export function getContractPaymentDepositSetting(
  params: any,
): Promise<ApiResponse> {
  const url = `${BASE_URL}Payment/DepositSetting/Contract`;
  return makeApiCall(url, "GET", params);
}

// Create a new source
export function savePaymentDepositSetting(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}Payment/DepositSetting`, "POST", body);
}

export function deletePaymentDepositSetting(
  paymentDepositSettingId: number,
): Promise<ApiResponse> {
  const url = `${BASE_URL}Payment/DepositSetting/${paymentDepositSettingId}`;
  return makeApiCall(url, "DELETE");
}

/**************************************** Templates ********************************************************* */
export function getAllClienttemplates(
  locationId?: number,
  referenceId?: string,
  filters?: {
    isPrintable?: boolean;
    isEmailable?: boolean;
  },
): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/templates`, "GET", {
    locationId: locationId,
    referenceTypeId: referenceId,
    isPrintable: filters?.isPrintable,
    isEmailable: filters?.isEmailable,
  });
}

export function getClientSubscriptions(clientId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/${clientId}/subscriptions`, "GET");
}

export function getPublicSubscriptionStatus(clientCode: string): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/public/subscription-status`, "GET", { clientCode });
}

/**************************************** Filter Configs ********************************************************* */
export function getFilterConfigs(
  referenceType: string,
  userId?: number,
  signal?: AbortSignal,
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}clients/filterConfigs`,
    "GET",
    {
      referenceType,
      userId,
    },
    null,
    signal,
  );
}

export function saveFilterConfigs(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}clients/filterConfigs`, "POST", body);
}
